import { VIEW_MODE } from '@/shared/hooks';
import { LoadingRegion } from '@/shared/ui/skeletons';
import { useReelSessionViewMode } from '../../model/useReelSessionViewMode';
import { ReelSessionCardSkeleton } from '../ReelSessionCard';
import { ReelSessionRowHeader, ReelSessionRowSkeleton } from '../ReelSessionRow';
import { CARD_GRID_CLASS, LIST_CONTAINER_CLASS } from './listLayout';

const SKELETON_ITEMS = 4;
const SKELETONS = Array.from({ length: SKELETON_ITEMS });

/** The list's own frame and the view mode the person last chose, so the swap to loaded sessions shifts nothing. */
export const ReelSessionListSkeleton = () => {
  const { viewMode } = useReelSessionViewMode();

  return (
    <div className={LIST_CONTAINER_CLASS}>
      <LoadingRegion data-testid="reel-session-list-skeleton">
        {viewMode === VIEW_MODE.cards ? (
          <div className={CARD_GRID_CLASS}>
            {SKELETONS.map((_, index) => (
              <ReelSessionCardSkeleton key={index} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col">
            <ReelSessionRowHeader />
            {SKELETONS.map((_, index) => (
              <ReelSessionRowSkeleton key={index} />
            ))}
          </div>
        )}
      </LoadingRegion>
    </div>
  );
};
